import { useFilialContext } from '@/context/FilialContext';

export const useFilialSelecionada = () => {
  return useFilialContext();
};


